import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription, take } from 'rxjs';
import { UserSettings, APIResponse } from 'fakturnia-shared';
import { SettingsApiService } from 'shared/services/api/settings.api.service';
import { SettingsService } from 'shared/services/settings.service';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  standalone: true,
  selector: 'enable-pkwiu',
  imports: [CommonModule, MatCheckboxModule, MatSlideToggleModule, MatIconModule, MatTooltipModule],
  templateUrl: './enable-pkwiu.component.html',
  styleUrls: ['./enable-pkwiu.component.scss']
})
export class EnablePkwiuComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = [];
  
  enablePKWiU = false;
  showPKWiU = true;
  isProcessingEnable = false;
  isProcessingShow = false;

  constructor(
    private _settingsApiService: SettingsApiService,
    private _settingsService: SettingsService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this._subscriptions.push(
      this._settingsService.getUserSettings().subscribe({
        next: (userSettings: UserSettings) => {
          this.enablePKWiU = userSettings.settings.autocomplete.enablePKWiU || false;
          this.showPKWiU = userSettings.settings.autocomplete.showPKWiU !== undefined ? userSettings.settings.autocomplete.showPKWiU : true;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  toggleEnablePKWiU(): void {
    if (this.isProcessingEnable) return;
    
    this.isProcessingEnable = true;
    const newValue = !this.enablePKWiU;
    this.enablePKWiU = newValue;
    
    this._settingsApiService.updateEnablePKWiU(this.enablePKWiU)
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {
          if (response.success) {
            // Odśwież ustawienia, aby inne komponenty otrzymały aktualizację
            // Lokalna wartość jest już zaktualizowana, więc nie będzie migania
            this._settingsService.refreshSettings();
            this._snackbarService.showSnackBar('Zapisano zmiany', 'success', 4000);
          } else {
            this._snackbarService.showSnackBar('Nie udało się zapisać zmian', 'error', 4000);
            // Revert change on error
            this.enablePKWiU = !this.enablePKWiU;
          }
          this.isProcessingEnable = false;
        },
        error: () => {
          this._snackbarService.showSnackBar('Wystąpił błąd podczas zapisywania', 'error', 4000);
          // Revert change on error
          this.enablePKWiU = !this.enablePKWiU;
          this.isProcessingEnable = false;
        }
      });
  }

  toggleShowPKWiU(): void {
    if (this.isProcessingShow) return;
    
    this.isProcessingShow = true;
    const newValue = !this.showPKWiU;
    this.showPKWiU = newValue;
    
    this._settingsApiService.updateShowPKWiU(this.showPKWiU)
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {
          if (response.success) {
            // Odśwież ustawienia, aby inne komponenty otrzymały aktualizację
            // Lokalna wartość jest już zaktualizowana, więc nie będzie migania
            this._settingsService.refreshSettings();
            this._snackbarService.showSnackBar('Zapisano zmiany', 'success', 4000);
          } else {
            this._snackbarService.showSnackBar('Nie udało się zapisać zmian', 'error', 4000);
            // Revert change on error
            this.showPKWiU = !this.showPKWiU;
          }
          this.isProcessingShow = false;
        },
        error: () => {
          this._snackbarService.showSnackBar('Wystąpił błąd podczas zapisywania', 'error', 4000);
          // Revert change on error
          this.showPKWiU = !this.showPKWiU;
          this.isProcessingShow = false;
        }
      });
  }
}

